import { Box, styled } from '@mui/material';

const Layout = styled(Box)({
  margin: '0 auto',
  width: '100%',
  maxWidth: '1200px',
});

export default Layout;
